module.exports = __webpack_public_path__ + "img/logo_holidayhub.b979e00f.svg";